import { createAsyncThunk } from '@reduxjs/toolkit';
import { patchFloorplan } from '../services/patchFloorplan.service';

/**
 * Updates a floorplan: every field given besides the ids is sent as it is
 * (a null clears the field on the row), fields left out are left alone.
 */
export const updateFloorplan = createAsyncThunk(
  'floorplans/updateFloorplan',
  async ({ floorplanId, projectId, ...fields }) => {
    const updateParams = Object.fromEntries(
      Object.entries(fields).filter(([, value]) => value !== undefined)
    );

    const floorplan = await patchFloorplan(
      floorplanId,
      projectId,
      updateParams
    );
    return floorplan;
  }
);
